import { call, put, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACT from "./actions";
import {  getSettingsApi,getFaqsApi } from "helpers/backend_helper";
import {errorMsg, successMsg} from "helpers/toastr";
 /**
      * Used for calling the api for home page
      */


function* getSettingsSaga({ payload }) {
  try {
    const response = yield call(getSettingsApi, payload);
    if (response.status == "failure") {
      return yield put(ACT.getSettingsFail(response.message));
    }
    yield put(ACT.getSettingsSuccess(response));
    localStorage.setItem("userSettings", JSON.stringify(response))
  } catch (error) {
    yield put(ACT.getSettingsFail(error));
  }
}


function* getFaqsSaga({ payload }) {
  try {
    const response = yield call(getFaqsApi, payload);
    if (response.status == "failure") {
      return yield put(ACT.getFaqsFail(response.message));
    }
    yield put(ACT.getFaqsSuccess(response));
  } catch (error) {
    yield put(ACT.getFaqsFail(error));
  }
}



function* settingsSaga() {
  yield takeEvery(CONST.GET_SETTINGS, getSettingsSaga);
  yield takeEvery(CONST.GET_FAQS, getFaqsSaga);

}

export default settingsSaga;
